import { request } from '@/api/client';

export interface WecomDepartment {
  id: number;
  name: string;
  parentid: number;
}

export interface WecomDeptUser {
  userId: string;
  name: string;
  alreadyJoined: boolean;
}

export interface WecomInviteItem {
  wecomUserId: string;
  name: string;
}

export interface WecomInviteFailure {
  wecomUserId: string;
  reason: string;
}

export interface WecomInviteResult {
  invited: { id: string; name: string; email: string; role: string }[];
  skipped: string[];
  failed: WecomInviteFailure[];
}

export function fetchWecomDepartments(): Promise<WecomDepartment[]> {
  return request<WecomDepartment[]>('/wecom/departments');
}

export function fetchWecomDeptUsers(deptId: number): Promise<WecomDeptUser[]> {
  return request<WecomDeptUser[]>(`/wecom/departments/${deptId}/users`);
}

export function inviteWecomUsers(items: WecomInviteItem[]): Promise<WecomInviteResult> {
  return request<WecomInviteResult>('/wecom/invite', { method: 'POST', body: { items } });
}
